import { DEFAULT_HOMEPAGE_CONFIG } from 'constants/configs';
import { createContext } from 'react';
import { HomePageConfig } from 'types';

export const HomePageConfigContext = createContext<HomePageConfig>(DEFAULT_HOMEPAGE_CONFIG);
